Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../../styles");
var _Icon = require("../styles/useTypeStyles/Icon");
var useStyles = exports.useStyles = function useStyles() {
  var _useIcon = (0, _Icon.useIcon)(),
    sizes = _useIcon.sizes;
  var _scale = 0.6;
  var _container = {
    alignItems: 'center',
    justifyContent: 'center'
  };
  var styles = _reactNative.StyleSheet.create({
    container_small: Object.assign({}, _container, {
      width: (0, _styles.getREM)(sizes.small),
      height: (0, _styles.getREM)(sizes.small + sizes.border * 2)
    }),
    container_normal: Object.assign({}, _container, {
      width: (0, _styles.getREM)(sizes.normal),
      height: (0, _styles.getREM)(sizes.normal + sizes.border * 2)
    }),
    container_large: Object.assign({}, _container, {
      width: (0, _styles.getREM)(sizes.large),
      height: (0, _styles.getREM)(sizes.large + sizes.border * 2)
    }),
    icon_small: {
      width: (0, _styles.getREM)(sizes.small * _scale),
      height: (0, _styles.getREM)(sizes.small * _scale)
    },
    icon_normal: {
      width: (0, _styles.getREM)(sizes.normal * _scale),
      height: (0, _styles.getREM)(sizes.normal * _scale)
    },
    icon_large: {
      width: (0, _styles.getREM)(sizes.large * _scale),
      height: (0, _styles.getREM)(sizes.large * _scale)
    }
  });
  return {
    styles: styles
  };
};